import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import ShapeTwo from '../../components/shape-two'
import Accordion from '../../components/accordion'
import Shape from '../../components/shape'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/bg.jpg'

import { helpFeature } from '../../data'

export default function HelpOverview() {
  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">Overview</h4>
                          <p className="text-muted mb-0">General and business related question and answer are here,</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Help Center</Link></li>
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Overview</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12">
                  <div className="section-title text-center mb-4 pb-2">
                      <h4 className="mb-4">Find the help you need</h4>
                      <p className="para-desc mx-auto text-muted">Launch your campaign and benefit from our expertise on designing and managing conversion centered bootstrap v5 html page.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {helpFeature.map((item,index)=>{
              let Icon = item.icon
              return(
                  <div className="col-md-4 col-12 mt-4 pt-2" key={index}>
                      <div className="card feature border-0 shadow rounded text-center p-4 py-5">
                          <div className="content">
                              <Icon className={item.iconColor}/>
                              <h4 className="title mt-3">{item.title}</h4>
                              <p className="text-muted">{item.desc}</p>
                              <Link to={item.link} className="text-primary">Read More <i className="mdi mdi-chevron-right"></i></Link>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row justify-content-center">
              <div className="col-12">
                  <div className="section-title text-center mb-4 pb-2">
                      <h4 className="mb-4">Get Started</h4>
                      <p className="para-desc mx-auto text-muted">Launch your campaign and benefit from our expertise on designing and managing conversion centered bootstrap v5 html page.</p>
                  </div>
              </div>
          </div>

          <div className="row justify-content-center">
              <div className="col-lg-9 mt-4 pt-2">
                  <Accordion/>
              </div>
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
